<template>
  <div class="mb-4">
    <label for="exampleFormControlInput1" class="text-sm font-medium text-black">{{ props.label }}</label>
    <div class="flex mt-2">
      <input
        v-model="password"
        @change="updateValue"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Enter password"
        required
        data-testid="password"
        :disabled="props.disabled"
        class="border placeholder:text-gray-600 rounded rounded-e-none w-full py-2 px-3 text-gray-700 leading-tight"
      />
      <button
        class="p-2 bg-white text-black font-semibold hover:text-black border hover:border-gray-100 rounded rounded-s-none"
        type="button"
        id="showPasswordButton"
        tabindex="-1"
        @click="showPassword = !showPassword"
      >
        <i id="pswIcon" class="fa iconColor" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  disabled: boolean;
  label: string;
}>();

const password = ref('');
const showPassword = ref(false);

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: any) => {
  emit('update:modelValue', event.target.value);
};
</script>
